import React, { useCallback, useEffect, useState } from 'react';
import { createTheme } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DeleteIcon from "@material-ui/icons/Delete";
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import { DataGrid } from '@material-ui/data-grid';
import { isUndefined } from 'lodash';
import './EditTagsModal.scss';


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const defaultTheme = createTheme();
const useStyles = makeStyles(
  (theme) => {
    const border = '1px solid #DCDCDC';
    const borderRadius = '4px';
    return {
      root: {
        '& .MuiDataGrid-cell--editable': {
          border,
          borderRadius,
        },
      },
    };
  },
  { defaultTheme },
);

export default function AlertDialogSlide({ modalShow, modalState, id }) {
  const classes = useStyles();
  const [open, setOpen] = useState(modalShow);
  const [row, setRow] = useState([]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    modalState(false);
    // setOpen(false);
  };

  const handleAddNewRow = () => {
    if (!isUndefined(row)) {
      const lastId = row.slice(-1)[0];
      const obj = {
        id: lastId.id+1,
        tagName: "",
        tagValue: ""
      }
  
      return setRow(prevArray => [...prevArray, obj]);
    }
  }

  useEffect(() => {
    const data = JSON.parse(window.localStorage.getItem("uploadedContent"));

    if (data && id) {
      let content = data.filter(item => item.id === id)[0];
      const entries = Object.entries(content.tags);
      const arr = [];

      [...entries].map((item, index) => {
        const insideArr = item[0].indexOf("<");
        const tagNameVal = item[0].slice(insideArr).replace(/['}<>]/g, '');

        const obj = {
          id: index,
          tagName: tagNameVal,
          tagValue: item[1]
        };

        arr.push(obj);
      })

      return setRow(arr);
    }
  }, [id]);

  const columns = [
    { field: 'tagName', headerName: 'Tag Name (required)', width: 200, border: '1px solid gray', editable: true },
    { field: 'tagValue', headerName: 'Tag Value (optional)', width: 200, border: '1px solid gray', editable: true },
    {
      field: "delete",
      headerName: "Delete",
      sortable: false,
      width: 100,
      disableClickEventBubbling: true,
      renderCell: () => {
        return (
          <Button
            variant="contained"
            color="secondary"
            startIcon={<DeleteIcon />}
          >
            Delete
          </Button>
        );
      }
    }
  ];

  const [editRowsModel, setEditRowsModel] = useState({});

  const handleEditRowsModelChange = useCallback((model) => {
    setEditRowsModel(model);
  }, []);

  return (
    <div>
      <Button variant="outlined" onClick={handleClickOpen}></Button>
      <Dialog
        disableBackdropClick={true}
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description">
        <DialogTitle className="dialog-modal-title" id="alert-dialog-slide-title">Edit Tags</DialogTitle>
        <DialogContent className="dialog-modal content" >
          {/* <DialogContentText color="red[50]" classname="dialog-modal-contexts" id="alert-dialog-slide-description" >
            Edit Tags
          </DialogContentText> */}
          <div className="data-grid-container" style={{ height: 400, width: '100%' }}>
            <DataGrid
              className={classes.root}
              rows={!isUndefined(row) ? row : ""}
              columns={columns}
              editRowsModel={editRowsModel}
              onEditRowsModelChange={handleEditRowsModelChange}
            />
          </div>
        </DialogContent>
        <DialogActions className="dialog-modal-action">
          <div>
            <Button variant="contained" color="default" onClick={handleAddNewRow}>Add Row</Button>
          </div>
          <div>
            <Button variant="contained" color="default" onClick={handleClose} >
              Cancel
            </Button>
            <Button className="color-changer" variant="contained" style={{ marginLeft: '10px' }} onClick={handleClose} >
              OK
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
}
